<template>
  <div>
    <div class="header">
      <h1 class="page-title">第三方流水</h1>
    </div>
    <el-card class="box-card">
      <div slot="header" class="card_header clearfix">
        <div class="block">
          <span>选择日期</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            @change="date()"
          ></el-date-picker>
          <input type="text" v-model="keywords" placeholder="请输入您要搜索的内容" />
          <button class="searchBtn" @click="selectconsume()">搜索</button>
        </div>
        <div class="totalInfo">
          <span>
            总条数:
            <i>{{totalNum + '条'}}</i>
          </span>
          <span>
            总计:
            <i>{{totalPirce + '元'}}</i>
          </span>
        </div>
      </div>

      <div class="main">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column type="index"  :index="indexMethod" label="序号"></el-table-column>
          <el-table-column prop="account_no" label="消费单号"></el-table-column>
          <el-table-column prop="account_type" label="充值种类">
            <template slot-scope="scope">{{account_type[scope.row.account_type]}}</template>
          </el-table-column>
          <el-table-column prop="order_amount" style="word-break: normal;"  label="实付金额"></el-table-column>
          <el-table-column prop="order_no" style="word-break: normal;" label="订单号"></el-table-column>
          <el-table-column prop="realy_price" style="word-break: normal;" label="订单金额"></el-table-column>
          <el-table-column prop="order_file" label="文件名"></el-table-column>
          <el-table-column prop="order_memo" label="订单备注"></el-table-column>
          <el-table-column prop="pay_mode" label="支付方式">
              <template slot-scope="scope">{{scope.row.pay_mode}}</template>
          </el-table-column>
          <el-table-column prop="third_no" label="第三方单号"></el-table-column>
          <el-table-column prop="serial_no" label="流水号"></el-table-column>

          <el-table-column prop="user_id" label="会员ID"></el-table-column>
          <el-table-column prop="createtime" label="订单日期">
             <template slot-scope="scope">{{scope.row.createtime | dateFormat}}</template>
          </el-table-column>
          <el-table-column prop="order_status" label="订单状态">
            <template slot-scope="scope">{{orderstatus[scope.row.order_status]}}</template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="totalNum"
      ></el-pagination>
    </el-card>

   <!-- <a
      :href="baseUrl + `/api/mine/consume/explode/1/uid/${uId}${mindate==''?'':`/mindate/${mindate}`}${maxdate==''?'':`/maxdate/${maxdate}`}${keywords==''?'':`/keywords/${keywords}`}`"
      id="exportTable"
      class="btn btn-default"
    >导出excel</a> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 时间
      value2: '',
      token: window.localStorage.getItem('token'),
      mindate: '',
      maxdate: '',
      page: 1,
      pickerOptions: {
        shortcuts: [
          {
            text: '当天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '当月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth())
              start.setDate(1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '上月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setMonth(start.getMonth() - 1)
              start.setDate(1)
              end.setMonth(start.getMonth() + 1)
              end.setDate(0)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      tableData: [],
      totalNum: 0,
      totalPirce: 0.00,
      loading: true,
      keywords: '',
      uId: '',
      baseUrl: '',
      filter: {},
      op: {},
      account_type: { '1': '订单消费', '2': '售后退款', '3': '取消转充值', '5': '会员充值', '6': '充值赠送', '7': '后台充值' },
      billtype: { '1': '收入', '2': '支出' },
      orderstatus: { '1': '正常', '2': '售后', '3': '取消' },
      paytype: { '1': '余额支付', '2': '支付宝', '3': '微信', '5': '后台充值' }
    }
  },
  created() {
    const url = window.location.host
    this.baseUrl = !url.includes('192')
      ? 'http://' + url
      : 'https://www.yunshanyin.net'
    if (window.localStorage.getItem('u')) {
      let u = window.localStorage.getItem('u')
      this.uId = JSON.parse(u).id
    }
    if (!window.localStorage.getItem('token')) {
      this.$router.replace('/login')
      return
    }
    this.queryConcume()
    this.getYue()
  },
  methods: {
    // 用户余额
    async getYue() {
      let param = new URLSearchParams()
      param.append('token', window.localStorage.getItem('token'))
      const { data: res } = await this.$http({
        method: 'post',
        url: 'api/mine/index',
        data: param
      })
      $('.money span').text(res.data.money + '元')
    },
    indexMethod(index) {
      if (this.page == 1) {
        return index + 1
      }
      if (index + 1 == 10) {
        return this.page + '' + 0
      }
      return this.page - 1 + '' + (index + 1)
    },
    handleCurrentChange(value) {
      this.page = value
      this.queryConcume()
    },
    // 补0
    PrefixInteger(num, length) {
      return ('00000000' + num).substr(-length)
    },
    // 搜素
    selectconsume() {
      this.page = 1
      this.queryConcume()
    },
    // 时间
    date() {
      if (this.value2 != null) {
        this.mindate = this.value2[0] + ' 00:00:00'
        this.maxdate = this.value2[1] + ' 23:59:59'
      } else {
        this.mindate = ''
        this.maxdate = ''
      }
    },
    //   消费，明细
    async queryConcume() {
      this.loading = true
      let url = '/admin/newbill/order/third?addtabs=1&offset=' + (this.page * 10 - 10) + '&limit=10'
      if (this.keywords) {
        url += '&search=' + this.keywords
      }
      if (this.mindate && this.maxdate) {
        url += '&filter={"user_id":"' + this.uId + '","createtime":"' + this.mindate + ' - ' + this.maxdate + '"}&op={"user_id":"in","createtime":"RANGE"}'
      } else {
        url += '&filter={"user_id":"' + this.uId + '"}&op={"user_id":"in"}'
      }
      const { data: res } = await this.$http.get(url, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
      this.loading = false
      if (res.rows) {
        let data = res.rows
         for (let i = 0; i < data.length; i++) {
           if (data[i]['realy_price']) {
             let arr = data[i]['realy_price'].split(',')
             let str = ''
             for (let ii = 0; ii < arr.length; ii++) {
                 str += arr[ii] + '元'
             }
             data[i]['realy_price'] = str
           }
           if (data[i]['realy_price']) {
             let arr = data[i]['order_no'].split(',')
             let str = ''
             for (let ii = 0; ii < arr.length; ii++) {
                 str += '' + arr[ii]
             }
             data[i]['order_no'] = str
           }
           if (data[i]['order_file']) {
             let arr = data[i]['order_file'].split('@,@')
             let str = ''
             for (let ii = 0; ii < arr.length; ii++) {
                 str += '' + arr[ii]
             }
             data[i]['order_file'] = str
           }

           if (data[i]['account_type'] == 5) {
             data[i]['order_no'] = '无'
             data[i]['order_file'] = '无'
           }
          }
        this.tableData = data
        this.totalNum = res.total
        this.totalPirce = res.money
      }
    }
  }
}
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 20px;
  .page-title {
    font-size: 24px;
  }
}
.card_header {
  position: relative;
  .totalInfo {
    position: absolute;
    top: 50px;
    right: 20px;
    span {
      font-size: 18px;
      margin-right: 18px;
      i {
        color: #e83030;
      }
    }
  }
}
.el-card {
  .block {
    position: relative;
    margin-top: 30px;
    span {
      margin-right: 10px;
      color: #666;
    }
    input {
      box-shadow: 0px 0px 1px 1px #eee;
      padding-left: 10px;
      margin-left: 30px;
      width: 220px;
      height: 30px;
    }
    .searchBtn {
      padding: 8px 20px;
      margin-top: 5px;
      margin-left: 15px;
      color: #fff;
      background: #a77c5a;
      border-radius: 3px;
    }
    .sy-zongj {
      position: absolute;
      top: 13px;
      left: 800px;
      font-size: 16px;
      b {
        color: #e83030;
      }
    }
  }
  .main {
    font-size: 12px;
    .cz {
      font-size: 12px !important;
      margin-left: 5px;
    }
  }
  .el-pagination {
    margin: 40px 0 0 700px;
  }
}
</style>
